<app-static-header></app-static-header>
<div class="router-container">
  <router-outlet></router-outlet>
</div>

<app-loader [isLoading$]="isLoading$"></app-loader>
<app-loader [isLoading$]="sseLoading$"></app-loader>